var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
import createCase from './createCase';
export var initialState = {
    operationId: '',
    postCasesCount: 0,
    expectedResolutionDate: '',
    disputeCreated: false,
    error: null,
    status: '',
    lowBalanceDisputeApplied: false,
    lowBalanceDisputeAdjustedAmount: '',
    disputeReason: ''
};
var casesSlice = createSlice({
    name: 'cases',
    initialState: initialState,
    reducers: {
        clearCasesState: function () {
            return initialState;
        },
        updateCaseDetails: function (state, action) {
            var payload = action.payload;
            return __assign(__assign({}, state), payload);
        }
    },
    extraReducers: function (builder) {
        builder.addCase(createCase.fulfilled, function (state, action) {
            return __assign(__assign(__assign({}, state), action.payload), { postCasesCount: 0 });
        });
        builder.addCase(createCase.rejected, function (state) {
            state.postCasesCount += 1;
        });
    }
});
export var clearCasesState = (_a = casesSlice.actions, _a.clearCasesState), updateCaseDetails = _a.updateCaseDetails;
export default casesSlice.reducer;
//# sourceMappingURL=cases.slice.js.map